const formsPinkishBlur = "/_app/immutable/assets/forms-pinkish-blur.D7ku142L.png";
export {
  formsPinkishBlur as default
};
